import axios from "axios";
import authHeader from "./AuthHeader";
import AuthService from "../service/AuthService";

const api_url = process.env.REACT_APP_URL;
const slug = AuthService.getLng() + "/tirebooking/cevent/";
const basicSlug = AuthService.getLng() + "/tirebooking/ceventbasicinfo/";
const bodyParameters = {
};

export class EventService {
    getEvents() {
        return axios
            .get(api_url + slug, {
                headers: authHeader(),
            })
            .then((res) => res.data.results);
    }

    getEventsByCalendar(id, startDate, endDate) {
        const today = new Date().toISOString().split('T')[0];
        const fromDate = startDate || today;
        const query = ['calendar=' + id, 'event_start=' + fromDate];

        if (endDate) {
            query.push('event_end=' + endDate);
        }

        return axios
            .get(api_url + basicSlug + '?' + query.join('&'), {
                headers: authHeader(),
            })
            .then((res) => res.data.results);
    }

    getEvent(id) {
        return axios
            .get(api_url + slug + id + "/", {
                headers: authHeader(),
            })
            .then((res) => res.data);
    }

    deleteEvent(id) {
        return axios
            .delete(api_url + slug + `${id}/`, { headers: authHeader() })
            .then((res) => res.data.results);
    }

    createEvent(data) {
        return axios.post(api_url + slug, bodyParameters, {
            headers: authHeader(),
            data,
        });
    }

    updateEvent(id, data) {
        return axios.put(api_url + slug + `${id}/`, bodyParameters, {
            headers: authHeader(),
            data,
        });
    }

    getOptions() {
        return axios
            .options(api_url + slug, {
                headers: authHeader(),
            })
            .then((res) => res.data.actions.POST);
    }
}
